import React from "react";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
} from "@chakra-ui/react";

import submit_custom_request_icon from "../../../assets/images/icons/submit_custom_request_icon.png";

export default function ModalNewCustomRequestViewComponent(props) {
  const { isOpen, onClose } = props;
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <div className="flex flex-row gap-2">
              <div className="h-6 w-6  flex flex-col justify-center ">
                <img src={submit_custom_request_icon} />
              </div>

              <h4>New Custom Files Request</h4>
            </div>
          </ModalHeader>

          <ModalBody>
            <div className="flex flex-col gap-5">
              <h2>
                Your request for custom file differences has been successfully
                submitted
              </h2>

              <p>
                You'll receive an email with the updated files shortly. In the
                meantime, you can check the status of your request on the Custom
                Requests screen.
              </p>
            </div>
          </ModalBody>

          <ModalFooter>
            <div className="flex flex-row justify-end">
              <div className="w-[16.1rem] h-[3.13]">
                <Button onClick={onClose}>Back to My Custom Requests</Button>
              </div>
            </div>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
